import Image from "next/image";
import IconSparkles from "@/app/(components)/generics/Icons/IconSparkles";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { UStyles } from "@/app/utils/UStyles";
import { HOW_FILE_AVATAR_SIZE, HOW_FILE_CUSTOMER, HOW_FILE_EVENTS } from "./HowItWorks.logic";
import styles from "./HowItWorksMock.module.css";
import HowItWorksMockFileEvent from "./HowItWorksMockFileEvent";

export default function HowItWorksMockCustomerFile() {
  const T = useT();

  return (
    <div className={styles.card}>
      <div className={styles.identity}>
        <Image
          className={styles.avatar}
          src={HOW_FILE_CUSTOMER.photo}
          alt=""
          width={HOW_FILE_AVATAR_SIZE}
          height={HOW_FILE_AVATAR_SIZE}
          unoptimized
        />
        <span className={styles.rowTexts}>
          <span className={styles.customerName}>{HOW_FILE_CUSTOMER.name}</span>
          <span className={styles.meta}>
            {`${T(TKey.HOME_MEIDLY_HOW_MOCK_JOB_TITLE)} · ${HOW_FILE_CUSTOMER.company}`}
          </span>
        </span>
        <span className={styles.badge}>{T(TKey.CUSTOMER_RELATIONSHIP_ACTIVE)}</span>
      </div>

      <div className={styles.timeline}>
        <div className={styles.event}>
          <span className={UStyles.classNames(styles.eventNode, styles.eventNodeAi)}>
            <IconSparkles />
          </span>
          <span className={styles.eventBody}>
            <span className={styles.meta}>{T(TKey.CUSTOMER_SYNTHESIS_TITLE)}</span>
            <span className={styles.summary}>{T(TKey.HOME_MEIDLY_HOW_FILE_SUMMARY)}</span>
          </span>
        </div>
        {HOW_FILE_EVENTS.map((event) => (
          <HowItWorksMockFileEvent key={event.titleKey} event={event} />
        ))}
      </div>
    </div>
  );
}
